module.exports = __webpack_public_path__ + "img/The Coroner's Gambit.9de01611.jpg";